import React, { useMemo } from 'react';

const FUNNEL_STEPS = [
  { key: 'dsgvo', label: 'DSGVO akzeptiert', step: 1 },
  { key: 'type_selected', label: 'Beratungsart gewaehlt', step: 2 },
  { key: 'date_selected', label: 'Datum gewaehlt', step: 3 },
  { key: 'slot_selected', label: 'Uhrzeit gewaehlt', step: 4 },
  { key: 'contact_filled', label: 'Kontakt ausgefuellt', step: 5 },
  { key: 'summary_viewed', label: 'Zusammenfassung', step: 6 },
  { key: 'booking_completed', label: 'Buchung abgeschlossen', step: 7 },
];

const FunnelChart = ({ funnelData, totalSessions }) => {
  const steps = useMemo(() => {
    return FUNNEL_STEPS?.map((s, i) => {
      const count = funnelData?.[s?.key] ?? 0;
      const prevCount = i === 0 ? totalSessions : (funnelData?.[FUNNEL_STEPS?.[i - 1]?.key] ?? 0);
      const dropOff = prevCount > 0 ? Math.round(((prevCount - count) / prevCount) * 100) : 0;
      const barWidth = totalSessions > 0 ? Math.max((count / totalSessions) * 100, 4) : 4;
      return { ...s, count, prevCount, dropOff, barWidth };
    });
  }, [funnelData, totalSessions]);

  const completionRate = totalSessions > 0
    ? Math.round(((funnelData?.booking_completed ?? 0) / totalSessions) * 100)
    : 0;

  const biggestDropStep = steps?.reduce((max, s) => s?.dropOff > (max?.dropOff ?? 0) ? s : max, null);

  return (
    <div style={{ background: 'white', borderRadius: '20px', border: '1px solid #dde1e7', boxShadow: '0 4px 6px rgba(62,73,84,0.04), 0 10px 20px rgba(62,73,84,0.06)', overflow: 'hidden', marginBottom: '24px' }}>
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #dde1e7', background: '#3E4954', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
            <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'><polygon points='22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3'/></svg>
          </div>
          <div>
            <h2 style={{ fontFamily: 'var(--font-ui)', fontSize: '16px', fontWeight: 700, color: 'white', margin: 0 }}>Buchungs-Funnel</h2>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', fontFamily: 'var(--font-ui)', margin: 0 }}>Schritt-fuer-Schritt Abbruchanalyse</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '22px', fontWeight: 700, color: 'white', fontFamily: 'var(--font-heading)', lineHeight: 1 }}>{totalSessions?.toLocaleString('de-DE')}</div>
            <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.65)', fontFamily: 'var(--font-ui)' }}>Sitzungen gesamt</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '22px', fontWeight: 700, color: completionRate >= 20 ? '#4ade80' : completionRate >= 10 ? '#fbbf24' : '#f87171', fontFamily: 'var(--font-heading)', lineHeight: 1 }}>{completionRate}%</div>
            <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.65)', fontFamily: 'var(--font-ui)' }}>Abschlussrate</div>
          </div>
        </div>
      </div>
      {biggestDropStep && biggestDropStep?.dropOff > 0 && (
        <div style={{ padding: '12px 24px', background: 'rgba(220, 38, 38, 0.05)', borderBottom: '1px solid rgba(220, 38, 38, 0.12)', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='#dc2626' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
            <path d='M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z'/>
            <line x1='12' y1='9' x2='12' y2='13'/>
            <line x1='12' y1='17' x2='12.01' y2='17'/>
          </svg>
          <span style={{ fontSize: '12px', color: '#dc2626', fontFamily: 'var(--font-ui)', fontWeight: 600 }}>
            Groesster Abbruch bei {biggestDropStep?.label} - {biggestDropStep?.dropOff}% der Nutzer verlassen hier den Funnel
          </span>
        </div>
      )}
      <div style={{ padding: '24px' }}>
        {steps?.map((s, i) => (
          <div key={s?.key} style={{ marginBottom: i < steps?.length - 1 ? '8px' : 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '6px' }}>
              <div style={{
                width: '28px', height: '28px', borderRadius: '50%', flexShrink: 0,
                background: s?.key === 'booking_completed' ? '#16a34a' : '#3E4954',
                color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '12px', fontWeight: 700, fontFamily: 'var(--font-ui)',
              }}>
                {s?.step}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px', gap: '8px', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '13px', fontWeight: 600, color: '#1e2b38', fontFamily: 'var(--font-ui)' }}>{s?.label}</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
                    <span style={{ fontSize: '13px', fontWeight: 700, color: '#1e2b38', fontFamily: 'var(--font-ui)' }}>{s?.count?.toLocaleString('de-DE')}</span>
                    {i > 0 && s?.dropOff > 0 && (
                      <span style={{
                        fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '100px',
                        background: s?.dropOff >= 40 ? 'rgba(220,38,38,0.1)' : s?.dropOff >= 20 ? 'rgba(217,119,6,0.1)' : 'rgba(22,163,74,0.1)',
                        color: s?.dropOff >= 40 ? '#dc2626' : s?.dropOff >= 20 ? '#d97706' : '#16a34a',
                      }}>
                        -{s?.dropOff}%
                      </span>
                    )}
                    {i === 0 && (
                      <span style={{ fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '100px', background: 'rgba(62,73,84,0.08)', color: '#3E4954' }}>Start</span>
                    )}
                  </div>
                </div>
                <div style={{ height: '8px', background: '#f5f6f8', borderRadius: '100px', overflow: 'hidden' }}>
                  <div style={{
                    height: '100%', borderRadius: '100px',
                    width: s?.barWidth + '%',
                    background: s?.key === 'booking_completed' ?'linear-gradient(90deg, #16a34a, #4ade80)'
                      : s?.dropOff >= 40
                      ? 'linear-gradient(90deg, #dc2626, #f87171)'
                      : 'linear-gradient(90deg, #3E4954, #6b7a8d)',
                    transition: 'width 600ms cubic-bezier(0.4, 0, 0.2, 1)',
                  }} />
                </div>
              </div>
            </div>
            {i < steps?.length - 1 && (
              <div style={{ marginLeft: '40px', marginBottom: '4px' }}>
                <div style={{ width: '1px', height: '12px', background: '#dde1e7', marginLeft: '13px' }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FunnelChart;
